import { Route } from '@angular/router';
import { DOKUMENTE_PATH } from '../mgs-path-defs';

export const dokumenteRoute: Route = {
  path: DOKUMENTE_PATH,
  title: 'Dokumente',
  loadComponent: () => import('./dokumente.component')
};
